import PageHeader from "../components/PageHeader";
import HireUIUXDesignerContent from "../components/Hire-UIUX-Designer-Content";

const HireUIUXDesigner = () => {
    return (
        <>
            <PageHeader pagetitle="UI UX Designer" breadcrumbMenu="Home" breadcrumbMenuActive="UI UX Designer" image="/images/ui-ux-banner.jpg" />
            <HireUIUXDesignerContent />
        </>
    )
}

export default HireUIUXDesigner;